import { API } from "aws-amplify";

export default async function closeAccount(id) {
  return await API.post("general-info", "/close-account");
}
